import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import {
  DeleteOutline, ViewList, Event
} from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";



import { useTranslation } from "react-i18next";
import ProductsModal from '../../../services/ProductsModal';
import DatePickerModal from '../../../services/DatePickerModal';
import SourceModal from '../../../services/SourceModal';
import { cellFocusEditor, dateEditor  } from "../../../services/Common";
import "../common.css";



import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query';
import * as api from '../../../actions/api';
// react-tabulator
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator, reactFormatter } from 'react-tabulator';




import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const StockTakeFormData = (props) => {
  const { t } = useTranslation();
    //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "stock-take";
  const FacilityId = localStorage.getItem('FacilityId');
  const FacilityName = localStorage.getItem('FacilityName');

  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const classes = useStyles();
  const [manyTableData, setManyTableData] = useState([]);
  const [IsCompleted, setIsCompleted] = useState(false);

  
  
  const [open, setOpen] = useState(false); 
  const [openOrder, setOpenOrder] = useState(false);
  const [SoureOpen, setSoureOpen] = useState(false); 
  const [DatePickerOpen, setDatePickerOpen] = useState(false);
  const [datePickerAnchorEl, setDatePickerAnchorEl] = useState(null);
  const [deletedDataSet, setDeletedDataSet] = useState([]);

  const UsersListByFacility =JSON.parse(localStorage.getItem("UsersListByFacility"));
  const [currRowId, setCurrRowId] = useState(0);
  const [currFormulation, setCurrFormulation] = useState("");
 
  const UserInfo = encryptionService.decryptUserInfo();
  const RoleItemGroupId = UserInfo==0?'': UserInfo[0].ItemGroupId;
  const [currExpiryDate, setCurrExpiryDate] = useState("");





  /* =====Start of Print Excel Many Code==== */
const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

const PrintMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/esigl_stock_take_list_print.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&StockTakeId=" + props.formData.StockTakeId
     + "&FacilityId=" + FacilityId
     + "&FacilityName=" + FacilityName
     + "&RoleItemGroupId=" + props.formData.ItemGroupId
     + "&TimeStamp=" + Date.now()
  );
};

const ExcelMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/esigl_stock_take_list_excel.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&StockTakeId=" + props.formData.StockTakeId
     + "&FacilityId=" + FacilityId
     + "&FacilityName=" + FacilityName
     + "&RoleItemGroupId=" + props.formData.ItemGroupId
     + "&TimeStamp=" + Date.now()
  );
};
/* =====End of Excel Export Code==== */
  

     const manycolumns = [ 
      { title: t(DispensingLanguage[lan][menukey]['Actions']), field: 'custom', headerSort:false, headerHozAlign:"center", visible: false, hozAlign: 'center',width: 100,
       formatter: reactFormatter(<ActionButton />) } ,
       { title: "StockTakeItemsId", field: "StockTakeItemsId", visible: false }, 
       { title: 'Id', field: 'id',  visible:false },
       { title: t(DispensingLanguage[lan][menukey]['Sl#']), width:85, hozAlign: 'center', formatter: "rownum",headerSort:false, headerHozAlign:"center"},
       { title: t(DispensingLanguage[lan][menukey]['Product Code']), field: 'ItemCode',width:135,headerFilter:true,},
       { title: t(DispensingLanguage[lan][menukey]['Product Name']), field: 'ItemName', headerFilter:true,},
       { title: t(DispensingLanguage[lan][menukey]['Lot No']),
        field: 'BatchNo', hozAlign:"left",
        headerHozAlign:"left",width:100,
        editor: props.IsCompleted == 0 ? (props.isFirstPhysical==0?cellFocusEditor:''): '',   //"input" 
        cssClass: props.isFirstPhysical==0?"tabluator-column-editable text-field-editable":'',
        cellEdited: function (cell) {
 
          

        },
      
       },
       { title: t(DispensingLanguage[lan][menukey]['Expiry Date']), field: 'ExpiryDate', 
         hozAlign:"left",headerHozAlign:"left",width:100,
         cssClass: props.isFirstPhysical==0?"tabluator-column-editable text-field-editable":'',
        // editor: props.IsCompleted == 0 ? (props.isFirstPhysical==0?dateEditor:''): '', 
         editor: props.IsCompleted == 0 ? (props.isFirstPhysical==0?cellFocusEditor:''): '', 
          cellEdited: function (cell) {
            
            const curcellval = cell.getValue();
            const currow = cell.getRow();
            const rowdata = currow.getData(); 
          // props.setUpdatedDetailsGridDataHandler(rowdata);
          }
        },
        {
          title: "",
          headerSort: false,
          field: "custom",
          hozAlign: "center",
          width: 8,
          formatter: reactFormatter(<ShowDatePickerPopup />),
        },
        { 
          title: "SourceId",
          field: "SourceId",
          visible: false,
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Source"]),
          field: "SourceName",
          hozAlign: "left",
          width:120, 
          headerSort: false,
        },
        {
          title: "",
          headerSort: false,
          field: "custom",
          hozAlign: "center",
          width: 8,
          formatter: reactFormatter(<ShowSourcePopup />),
        },
       { title: t(DispensingLanguage[lan][menukey]['Stock Quantity']), field: 'StoreQty', hozAlign:"right",headerHozAlign:"right",width:100},
       { 
       title: t(DispensingLanguage[lan][menukey]['Physical Quantity']), 
       field: 'PhysicalQty',
       width:100, 
       hozAlign:"right",
       headerHozAlign:"right",
       editor: props.IsCompleted == 0 ? cellFocusEditor: '',   //"input"
       validator:["integer", "min:0"],
       cssClass: "tabluator-column-editable",
       cellEdited: function (cell) {

        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
       
        const pricecell = currow.getCell("AdjQuantity");
        const totprice =  curcellval!=""?curcellval-rowdata.StoreQty:"";
        pricecell.setValue(totprice);
        //props.setUpdatedDetailsGridDataHandler(currow._row.data);
        

       },
      },
       { title: t(DispensingLanguage[lan][menukey]['Adj. Quantity']), field: 'AdjQuantity',width:123, hozAlign:"right",headerHozAlign:"right"},
       { title: t(DispensingLanguage[lan][menukey]['Remarks']), 
       field: 'Remarks',
       width:110, 
       hozAlign:"left",  
       headerHozAlign:"left",
       cssClass: "tabluator-column-editable text-field-editable",
       editor: props.IsCompleted == 0? true : ''
      },
    
      
    ];

    const onPostBtnClick = () => { 
      setIsCompleted(true); 
      props.handlePost();
  
    }
  
    const onSaveUpdateBtnClick = () => { 
      if (props.isSubmitting) return;
      props.setUpdatedDetailsGridDataHandler(tblRef.table.getData()); 
    
    }

 
    const addProduct = (NonOrderProductData) => { 
      
      
      



 
      let temNonordata=NonOrderProductData;
      let rows = [];
   
      let autoId=0;
      temNonordata.forEach((row,i) => {
        autoId++
        let newRow={} ;
        newRow.ItemNo =row.ItemNo; 
        newRow.ItemCode =row.ItemCode; 
        newRow.ItemName =row.ItemName; 
  
        newRow.StockTakeItemsId = -1; 
        
        newRow.SKU=autoId;
        newRow.id=autoId;   
  
        newRow.BatchNo =null;
        newRow.ExpiryDate =null; 
        newRow.StoreQty = null;
        newRow.PhysicalQty = null;
        newRow.AdjQuantity = 0;
        newRow.Remarks=null; 
        newRow.SourceId = null;
        newRow.SourceName = null;


        rows.push(newRow);
      
    });

    manyTableData.forEach((row,i) => {
      autoId++;
      let newRow={} ; 
      newRow.ItemNo =row.ItemNo;
      newRow.ItemCode =row.ItemCode;
      
      newRow.ItemName =row.ItemName; 
      newRow.StockTakeItemsId = row.StockTakeItemsId; 
      newRow.SKU=autoId;
      newRow.id=autoId;   

      newRow.BatchNo = row.BatchNo;
      newRow.ExpiryDate =row.ExpiryDate; 
      newRow.StoreQty = row.StoreQty;
      newRow.PhysicalQty = row.PhysicalQty;
      newRow.AdjQuantity = row.AdjQuantity;
      newRow.Remarks=row.Remarks; 
      newRow.SourceId = row.SourceId;
      newRow.SourceName = row.SourceName;
      
      rows.push(newRow);
      
  }); 

       rows.sort((a, b) => (a.ItemName > b.ItemName) ? 1 : -1)
     


      setManyTableData(rows);  
      props.handleAdd(rows);  
      handleClose('Products');
     // handleClose("SourceClose");
    }; 


    const addSource = (productBatchData) => {
      if (!productBatchData) {
        return;
      }
  
      let temProductBatchData = productBatchData[0];
      let rows = [];
  
      let autoId = Date.now(); // 0;

      manyTableData.forEach((row, i) => {
        autoId++;
        let newRow={} ; 

        if (row.SKU === currRowId) {
          
          newRow.SourceId = temProductBatchData.SourceId;
          newRow.SourceName = temProductBatchData.SourceName;
         
          
        } else {
          newRow.SourceId = row.SourceId;
          newRow.SourceName = row.SourceName;
    
        }

        newRow.ItemNo =row.ItemNo;
        newRow.ItemCode =row.ItemCode;
        
        newRow.ItemName =row.ItemName; 
        newRow.StockTakeItemsId = row.StockTakeItemsId; 
        newRow.SKU=row.SKU;
        newRow.id=row.id; 
  
        newRow.BatchNo = row.BatchNo;
        newRow.ExpiryDate =row.ExpiryDate; 
        newRow.StoreQty = row.StoreQty;
        newRow.PhysicalQty = row.PhysicalQty;
        newRow.AdjQuantity = row.AdjQuantity;
        newRow.Remarks=row.Remarks;
        
        rows.push(newRow);

      });

      setManyTableData(rows);
      props.handleAdd(rows); 
      handleClose("SourceClose");
    };
  
    function ShowSourcePopup(propss: any) {
      const rowData = propss.cell._cell.row.data;

     
    if ((props.IsCompleted) || (props.isFirstPhysical)) {
        return <></>;
      } else {
        
        return (
          <>
            <ViewList
              onClick={() => {
                setCurrRowId(rowData.SKU);
                handleClose("SourceOpen");
              }}
            />
          </>
        );
     }
    }


    
  const addDatePicker = (datePickerData) => {
    if (!datePickerData) {
      return;
    }
    
    let selectedExpiryDate = format(new Date(datePickerData), 'dd/MM/yyyy');
    let rows = [];

    let autoId = Date.now(); // 0;

    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};

      
      if (row.SKU === currRowId) {

        newRow.ExpiryDate = selectedExpiryDate;
       
      } else {
        newRow.ExpiryDate = row.ExpiryDate;
      
      }


      newRow.ItemNo =row.ItemNo;
      newRow.ItemCode =row.ItemCode;
    
      newRow.ItemName =row.ItemName; 
      newRow.StockTakeItemsId = row.StockTakeItemsId; 
      newRow.SourceId = row.SourceId;
      newRow.SourceName = row.SourceName;
      newRow.SKU=row.SKU;
      newRow.id=row.id; 
    
      newRow.BatchNo = row.BatchNo;
      newRow.StoreQty = row.StoreQty;
      newRow.PhysicalQty = row.PhysicalQty;
      newRow.AdjQuantity = row.AdjQuantity;
      newRow.Remarks=row.Remarks;
    
      rows.push(newRow);

    });


    setManyTableData(rows);
    props.handleAdd(rows); 
    //productAdd(rows);
    handleClose("DatePickerClose");
  };

    
  function ShowDatePickerPopup(propss: any) {
    const rowData = propss.cell._cell.row.data;

    if ((props.IsCompleted) || (props.isFirstPhysical)) {
      return <></>;
    } else {
      
      return (
        <>
          <Event
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              setCurrRowId(rowData.SKU);
              setCurrFormulation(rowData.SKU);
              setCurrExpiryDate(rowData.ExpiryDate);
              setDatePickerAnchorEl({ top: rect.bottom, left: rect.left });
              handleClose("DatePickerOpen");
            }}
          />
        </>
      );
    }
  }



    const handleClose = (modalname) => {
      switch (modalname) {
        case "Products":
          setOpen(false);
          break;
        case "ProductsOpen":
          setOpen(true);
          break;
        case "OrderModal":
          setOpenOrder(false);
          break;
        case "OrderOpen":
          setOpenOrder(true);
           break; 

        case "SourceOpen":
          setSoureOpen(true);
          break;

        case "SourceClose":
            setSoureOpen(false);
            break;

        case "DatePickerOpen":
          setDatePickerOpen(true);
          break;
  
        case "DatePickerClose":
            setDatePickerOpen(false);
            setDatePickerAnchorEl(null);
            break;

        default:
          break;
      }
    }

    



  useEffect(() => {

    if(props.bFirst){
    setManyTableData(props.ManyTableData);
    }
    setIsCompleted(props.IsCompleted);

    setDeletedDataSet([]);
  }, [props.ManyTableData,props.IsCompleted]);




  const deleteReceiveInv = (data) => { 
    let newarray = manyTableData.filter(element => element !== data); 
    setManyTableData(newarray);
    if(data.StockTakeItemsId!=null){
      let newDeletedDataSet=[data.StockTakeItemsId]; 
      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));   
    } 
    
   
  };
  function ActionButton (propss) { 

  const rowData = propss.cell._cell.row.data; 
    
   if(rowData.StockTakeItemsId==-1){
    if (tblRef.table != null) tblRef.table.selectRow((rowData.id));
   }
 
    const cellValue = propss.cell._cell.value || 'Edit | Show';
    if(props.IsCompleted == 1)
    
    return (
      <>
         
      </>
    );
    else{

      if(rowData.StockTakeItemsId==-1)

      return (
        <>
         <DeleteOutline
            onClick={() => {
              deleteReceiveInv(rowData);
            }}
          /> 
        </>
      );
      else return (
        <>
         <DeleteOutline
            onClick={() => {
              deleteReceiveInv(rowData);
            }}
          /> 
        </>
      );



    } 
  }

  return (
    <div className={classes.productPageTitle}>
    <div className="sw_makeStyles_tableContainer">
      <div className="d-flex justify-product mb-3">
        <Grid container>
        <Grid item xs={12} sm={12}>

          <div className="sw_page_heading">
            <div className="sw_heading_title">{ DispensingLanguage[lan][menukey]['Stock Take - Add/Edit'] }</div>
          
          <div className="float-end sw_btn_control">

            {/* Action buttons */}
          {
            props.addProductForm ? (
              <Grid item xs={12} className="mt-4 text-center">
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.handleReset()}
                >
                  { DispensingLanguage[lan][menukey]['Reset'] }
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  disabled={!!props.isSubmitting}
                  onClick={() => {
                    if (props.isSubmitting) return;
                    props.handleSubmit();
                  }}
                >
                  { DispensingLanguage[lan][menukey]['Save'] } 
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/stock-take")}
                >
                  { DispensingLanguage[lan][menukey]['Back to List'] } 
                </Button>
              </Grid>
             ) : (
              <Grid item xs={12} className="mt-2 text-center">
                

                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={onSaveUpdateBtnClick}
                  //onClick={() => props.handleUpdate()}
                  disabled={!!props.IsCompleted || !!props.isSubmitting}
                >
                  { DispensingLanguage[lan][menukey]['update'] }  
                </Button>

                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  disabled={!!props.IsCompleted || !!props.isSubmitting}
                  onClick={onPostBtnClick}
                >
                 { DispensingLanguage[lan][menukey]['post'] }    
                </Button>

                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  //onClick={event =>  window.location.href='/order'}
                  onClick={() => props.history.push("/stock-take")}
                >
                  { DispensingLanguage[lan][menukey]['Back to List'] } 
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => PrintMany()}
                >
                <i className="fas fa-print"></i>
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => ExcelMany()}
                >
                <i className="far fa-file-excel"></i>
                </Button>




              </Grid>
         ) }
           {/* End Action buttons */}

          </div>
          </div>
        </Grid>
        </Grid>
      </div>


      <Grid container spacing={3} className="mb-3">
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                            <DatePicker
                  label= { DispensingLanguage[lan][menukey]['Start Date'] }
                  //disableToolbar
                  value={props.formData.StockTakeDate||props.selectedDate}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => props.handleRDateChange(e, "StockTakeDate")}
                  disabled={!!props.IsCompleted}
                                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    error={!!props.errorObject.StockTakeDate}
                    helperText={props.errorObject.StockTakeDate}
                    className={classes.fullWidth}
                    id="StockTakeDate"
                    name="StockTakeDate"
                    fullWidth
                  />
                )}
              />
        </LocalizationProvider>
      </Grid>
            
        <Grid item xs={2} sm={2}>
          <FormControl variant="standard" className={classes.fullWidth}>
          <InputLabel id="demo-simple-select-helper-label">
          
            {DispensingLanguage[lan][menukey]["Prepared By"]} *
          </InputLabel>
          <Select
            error={!!props.errorObject.PreparedBy}
            required
            labelId="demo-simple-select-helper-label"
            id="PreparedBy"
            name="PreparedBy"
            value={props.formData.PreparedBy ?? ""}
            fullWidth
            onChange={(e) => props.handleChange(e)}
            disabled={!!props.IsCompleted}
          label={`${DispensingLanguage[lan][menukey]["Prepared By"]} *`}>
            {UsersListByFacility.map((item, index) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
          <FormHelperText error={!!props.errorObject.PreparedBy}>
            {props.errorObject.PreparedBy}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={2} sm={2}>
        <FormControl variant="standard" className={classes.fullWidth}>
          <InputLabel id="demo-simple-select-helper-label">
          
            {DispensingLanguage[lan][menukey]["Approved By"]} *
          </InputLabel>
          <Select
            error={!!props.errorObject.ApprovedBy}
            required
            labelId="demo-simple-select-helper-label"
            id="ApprovedBy"
            name="ApprovedBy"
            value={props.formData.ApprovedBy ?? ""}
            fullWidth
            onChange={(e) => props.handleChange(e)}
            disabled={!!props.IsCompleted}
          label={DispensingLanguage[lan][menukey]["Approved By"]}>
          {UsersListByFacility.map((item, index) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
          <FormHelperText error={!!props.errorObject.ApprovedBy}>
            {props.errorObject.ApprovedBy}
          </FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                            <DatePicker
                  label= { DispensingLanguage[lan][menukey]['End Date'] }
                  // disableToolbar
                  value={props.formData.CompleteDate||props.selectedDate}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => props.handleRDateChange(e, "CompleteDate")}
                  disabled={!!props.IsCompleted}
                                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    error={!!props.errorObject.CompleteDate}
                    helperText={props.errorObject.CompleteDate}
                    className={classes.fullWidth}
                    id="CompleteDate"
                    name="CompleteDate"
                    fullWidth
                  />
                )}
              />
        </LocalizationProvider>
      </Grid>

        <Grid item xs={3} sm={3}>
          <TextField variant="standard" 
            id="FacilityId"
            name="FacilityId"
            label="FacilityId"  
            value={props.formData.FacilityId ?? ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
          <TextField variant="standard" 
            id="StockTakeId"
            name="StockTakeId"
            label="StockTakeId"  
            value={props.formData.StockTakeId || ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
        </Grid>  
      </Grid>

      <Grid container spacing={3}>
          {/* new row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={12}>
                    <div className="float-end sw_btn_control"> 

                    {
                        props.addProductForm ?
                          
                          <></>
                          :
                          <Grid item xs={12} className="mt-2 text-center"> 
                              
                            {props.isFirstPhysical?<></>
                            :
                            <Button
                              disabled={!!props.IsCompleted}
                              className="me-2"
                              variant="contained"
                              color="primary"
                              onClick={() => handleClose("ProductsOpen")}
                            >
                              {DispensingLanguage[lan][menukey]['SELECT NON-ORDER PRODUCT']}  
                            </Button> 

                            }
                        </Grid>
                      } 
                  </div>

                    <ProductsModal handleClose={handleClose} open={open} addProduct={addProduct} {...props} /> 
                    <SourceModal handleClose={handleClose} open={SoureOpen} addProduct={addSource} {...props} />
                    <DatePickerModal handleClose={handleClose} open={DatePickerOpen} anchorEl={datePickerAnchorEl} addDatePicker={addDatePicker} reload={0} ExpiryDate={currExpiryDate} {...props} />
                  </Grid>
                </Grid> 
              <div>
                <div className="uniqueName">
                  <ReactTabulator 
                  onRef={(r) => { tblRef.table = r.current; }}
                  columns={manycolumns}                    
                  data={manyTableData} 
                  layout={"fitColumns"}
                  height="340px"
                  />
                </div>
              </div> 
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    </div>
  </div>
  );
};

export default StockTakeFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
